import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChildrenProps } from "../../components/layout/Layout";
import useScrollLock from "./useScrollLock";

interface IContext {
  open: boolean;
  setOpen: (open: boolean) => void;
  selected: number;
  setSelected: (selected: number) => void;
}

const MenuContext = createContext<IContext | undefined>(undefined);

export const MenuContextProvider = ({ children }: ChildrenProps) => {
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const { lockScroll, unlockScroll } = useScrollLock();
  const [selected, setSelected] = useState<number>(-1);

  useEffect(() => {
    setOpen(false);
    setSelected(-1);
  }, [location]);

  useEffect(() => {
    if (!open) {
      setSelected(-1);
      unlockScroll();
    }
    open && lockScroll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <MenuContext.Provider
      value={{
        open,
        setOpen,
        selected,
        setSelected,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context)
    throw new Error(
      "No MenuContext.Provider found when calling useMenuContext"
    );
  return context;
};
